import { SVGProps } from 'react';

const MinusDriver = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={21} fill="none" {...props}>
    <path fill="#252736" d="M18.334 9.83v1.667H1.667V9.83z" />
  </svg>
);

export default MinusDriver;
